import i18n from '@core/i18n';

/**
 * Format a canvas text selection as a chat composer snippet.
 *
 * Produces a blockquote carrying the exact quoted text and its page number so
 * the agent can locate it in the report's render source, optionally prefixed
 * with an explicit change request. The words are in the user's language:
 * the snippet lands in their composer before they send it.
 */
export function formatCanvasQuote({ text, page, intent }, t = i18n.t.bind(i18n)) {
  const quoted = `> "${text}" (${t('workspace.canvasQuote.page', { page })})`;
  const prefix = intent === 'change' ? t('workspace.canvasQuote.changeRequest') : '';
  return `${quoted}\n\n${prefix}`;
}
